// ===========================================================================
// Welcome & OEP — constantes locales del módulo.
//
// Conectado al backend real (/api/WelcomeOep) desde 2026-09-10. Contrato:
// docs/modulos/CallCenter/WelcomeOEP/19_FRONT_WELCOME_OEP.md (guía front) y
// 18_ENDPOINTS_WELCOME_OEP.md (endpoints probados contra BD).
//
// Los catálogos de estado (OEP options, contact status) los resuelve el
// backend por key; acá solo viven las keys que el front necesita para armar
// requests y los labels de fallback cuando el server no manda nombre.
// ===========================================================================

// ---------------------------------------------------------------------------
// MANTENIMIENTO: en false el módulo opera normalmente. Ponerlo en true vuelve
// a publicar la página de aviso en /welcome-oep (ver index.js) sin tocar nada
// más — se usó mientras el backend no existía.
// ---------------------------------------------------------------------------
export const WELCOME_OEP_MAINTENANCE = false;

/** Tamaño de página del listado (default del backend; máx 100). */
export const PAGE_SIZE = 15;

// ---------------------------------------------------------------------------
// OEP Campaign Options — keys del catálogo backend (grupo welcome_oep_option).
// "pending" no es una opción elegible: es la cola sin trabajar (el picker la
// alcanza des-seleccionando la opción activa → se envía null).
// ---------------------------------------------------------------------------
export const OEP_OPTIONS = [
  { key: "email", label: "Email" },
  { key: "text", label: "Text" },
  { key: "video", label: "Video" },
  { key: "done", label: "OEP Done" },
];

// Status del contacto — keys del catálogo backend (grupo welcome_oep_contact).
export const MEMBER_STATUSES = [
  { key: "pending", label: "Pending" },
  { key: "contacted", label: "Contacted" },
  { key: "insurance_changed", label: "Insurance changed" },
  { key: "unable_to_contact", label: "Unable to contact" },
  { key: "refused", label: "Refused" },
];

// Idiomas canónicos EXACTOS que acepta PUT /{id}/language (validados en
// backend; "Creole" a secas es 400). Un miembro puede LLEGAR con un idioma de
// cola larga (p. ej. "Portuguese"): se renderiza tal cual, pero solo se puede
// cambiar a uno de estos tres.
export const LANGUAGES = ["English", "Spanish", "Haitian Creole"];
